import { getPublicCompanyRecord } from '../../api/companyRecords';

export async function getStorefrontEmployeeProfile({ companyId, employeeId }) {
  if (!companyId || !employeeId) return null;
  try {
    return await getPublicCompanyRecord({
      companyId,
      kind: 'employees',
      id: employeeId,
    });
  } catch (error) {
    if (error?.status === 404) return null;
    throw error;
  }
}

/**
 * Fills missing staff photo and name from the public employee catalog.
 */
export async function enrichStorefrontStaffFromPortalPattern({ companyId, ownerId, staffMember }) {
  if (!staffMember?.id || staffMember.isAnyAvailable) {
    return staffMember;
  }

  const employeeId = staffMember.id;
  let photoURL = staffMember.photoURL || staffMember.photoUrl || null;
  let firstName = staffMember.firstName;
  let lastName = staffMember.lastName;

  try {
    const employee = await getStorefrontEmployeeProfile({
      companyId: companyId || ownerId,
      employeeId,
    });
    if (employee) {
      photoURL = employee.photoURL || employee.photoUrl || photoURL;
      firstName = firstName || employee.firstName;
      lastName = lastName || employee.lastName;
    }
  } catch (e) {
    console.warn('[enrichStorefrontStaffFromPortalPattern]', employeeId, e);
  }

  const name = `${firstName || ''} ${lastName || ''}`.trim() || staffMember.name;

  return {
    ...staffMember,
    photoURL,
    firstName: firstName || '',
    lastName: lastName || '',
    name,
  };
}
